<template>
	<v-container class="white" grid-list-xl fluid ma-0 pa-0>
		<v-card class="body-1 pa-2 elevation-0" style="max-width: 99%">
			<v-row no-gutters>
				<v-col cols="12" sm="12" md="12"
					><br />
					<v-form ref="form" v-model="form" class="pa-1">
						<v-row>
							<v-col cols="12" sm="6" md="6">
								<v-text-field
									class="caption"
									ref="Json.Subject"
									dense
									background-color="amber lighten-5"
									v-model="Json.Subject"
									outlined
									filled
									placeholder=" "
									label="Subject"
								></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" sm="6" md="6">
								<v-textarea
									outlined
									class="caption"
									ref="this.SendTo"
									v-model="this.SendTo"
									placeholder="Emails"
									label="Sending To"
									height="100"
									background-color="green lighten-5"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<tiptap-vuetify
									ref="Json.EmailBody"
									height="200"
									v-model="Json.EmailBody"
									:extensions="extensions"
									@update="onUpdate"
									placeholder="Type your Message …"
									:toolbar-attributes="{ color: 'light-green lighten-4' }"
								/>
							</v-col>
						</v-row><br><br>
						<v-row></v-row>
						<v-toolbar-title class="caption mx-2">Sending To {{this.SendTo.length}} Email ID's</v-toolbar-title><br>
						<v-btn
							:disabled="!form"
							:loading="isLoading"
							class="white--text caption"
							color="indigo lighten-2"
							depressed
							@click="submit()"
							><v-icon class="mr-3">mdi-floppy</v-icon>Send</v-btn
						>
					</v-form>
				</v-col>
			</v-row> </v-card
		><br /><br />
	</v-container>
</template>

<script>
	import ReportServices from '@/services/ReportServices'
	import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History,CodeBlock, Image } from 'tiptap-vuetify'

	export default {
		components: { TiptapVuetify },
		data: () => ({
			isLoading: false,
			allCheckInStatus: [],
			extensions: [
				History,
				Blockquote,
				Link,
				Underline,
				Strike,
				Italic,
				ListItem,
				BulletList,
				OrderedList,
				[Heading, {
					options: {
					levels: [1, 2, 3, 4, 5]
					}
				}],
				Image,
				Bold,
				HorizontalRule,
				Paragraph,
				HardBreak,
				CodeBlock
			],
			Json: {
				Subject: '',
				EmailBody: ''
			},
			rules: {
				length: len => v => (v || '').length >= len ||`Invalid character length, required ${len}`,
				required: v => !!v || 'This field is required',
			},
		}),
		computed: {
			SendTo() {
				var emailToList = []
                this.allCheckInStatus.forEach(sInfo => {
                    if ( sInfo.eventpayment != "Paid" && sInfo.event == "VIV-2024")
                        emailToList.push(sInfo.primaryemail)
                })
				let uniqueEmailList = [...new Set(emailToList)]
				return uniqueEmailList.sort()
			}
		},
		methods: {
			submit() {
				this.Json.SendTo = this.SendTo
				ReportServices.sendBulkEmail(this.Json)
				this.$router.push('/ThankYou')
			},
			async refresh() {
				this.loading = true
				this.allCheckInStatus = (await ReportServices.getFDstatus()).data
				this.loading = false
				this.noDataText = 'No data available'
			},
		},
		async mounted() {
			this.refresh()
		}
	}
</script>
